export default {
  BRAND_COLORS: {
    PRIMARY: '#0095bc',
    SECONDARY: '#006884',
  },

  ROSE_DANGER_COLORS: {
    '-5': '#ccc',
    '-4': '#ccc',
    '-3': '#ccc',
    '-2': '#ccc',
    '-1': '#ccc',
    '0': '#0095bc',
    '1': '#4cb848',
    '2': '#fff300',
    '3': '#f8931d',
    '4': '#ed1d23',
    '5': '#000',
  },


  DANGER_COLORS: {
    '-5': '#ccc',
    '-4': '#ccc',
    '-3': '#ccc',
    '-2': '#ccc',
    '-1': '#ccc',
    '0': '#ccc',
    '1': '#4cb848',
    '2': '#fff300',
    '3': '#f8931d',
    '4': '#ed1d23',
    '5': '#000',
  },

  DANGER_RATINGS: {
    '-5': 'Spring Conditions',
    '-4': 'No Specific Avalanche Type',
    '-3': 'Centre Closed',
    '-2': 'Insufficient Snow',
    '-1': 'Insufficient Information',
    '0': 'No Rating',
    '1': 'Low',
    '2': 'Moderate',
    '3': 'Considerable',
    '4': 'High',
    '5': 'Extreme',
  },

  MAP_STYLES: {
    TOPOGRAPHIC: 'mapbox://styles/mapbox/outdoors-v11',
    SATELLITE: 'mapbox://styles/mapbox/satellite-v9',
    TOPOGRAPHIC_FORM: 'mapbox://styles/msc-admin/cjedn6pbs2xtf2rmp42b6bgzj',
  },

  TRAVEL_ADVICE: {
    '-5': 'Use normal caution; Plan your trip, Discuss your intentions with someone, Check the weather, Know how to recognise when you are in Avalanche terrain and Carry appropriate safety equipment.',
    '-4': 'Use normal caution; Plan your trip, Discuss your intentions with someone, Check the weather, Know how to recognise when you are in Avalanche terrain and Carry appropriate safety equipment.',
    '-3': 'Insufficient information the forecasting centre is currently closed.',
    '-2': 'Insufficient snow.',
    '-1': 'Insufficient information to establish avalanche problem rating.',
    '0': 'Insufficient information to establish avalanche problem rating.',
    '1': 'Generally safe avalanche conditions. Watch for unstable snow on isolated terrain features.',
    '2': 'Heightened avalanche conditions on specific terrain features. Evaluate snow and terrain carefully; identify features of concern.',
    '3': 'Dangerous avalanche conditions. Careful snowpack evaluation, cautious route-finding and conservative decision-making essential.',
    '4': 'Very dangerous avalanche conditions. Travel in avalanche terrain not recommended.',
    '5': 'Large to very large avalanches in many areas',
  },

  TRIGGER_TYPES: {
    unknown: "Unknown",
    natural: "Naturally occurring",
    skier: "Skier/Snowboarder",
    foot: "Person on foot"
  }
};
